import axios, { AxiosInstance, AxiosError, InternalAxiosRequestConfig } from 'axios'
import { toast } from 'react-toastify'

const axiosClient: AxiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/api`,
})

// Define the request interceptor
axiosClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    const token = localStorage.getItem('ACCESS_TOKEN')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error: AxiosError): Promise<InternalAxiosRequestConfig> => {
    return Promise.reject(error)
  }
)

// Define the response interceptor
axiosClient.interceptors.response.use(
  response => {

    response.data.success && toast.success( response.data.success || 'The operation was a successful!');
    
    response.data.info && toast.info( response.data.info );
    
    response.data.warning && toast.warning( response.data.warning );

    response.data.error && toast.error( response.data.error);

    return response.data
  },
  (error: AxiosError<{ message: string; errors: Record<string, string[]> }>) => {

    // un-comment in prod?
    /* if (error.response?.status === 429 || error.response?.status === 403) {
      window.location.reload()
      localStorage.clear()
    } */

    /* if (error.response?.status === 404) {
      window.dispatchEvent(new CustomEvent('navigate.invalid.page'))
    }
    */

    if (
      error.response?.status &&
      error.response.status !== 412 &&
      error.response.status !== 422 &&
      error.response.status > 399 &&
      error.response.status < 500
    ) {
      toast.warning(
        error.response?.data.message ||
          "We're having a temporary issue processing your request. Please try again in a few minutes. (Error : " +  error.response.status + ' )'
      )
    }

    if (error.response?.status && error.response.status >= 500) {
      toast.error(
        'Our server encountered an unexpected issue. Please give us a few moments to fix this. Error : ' +  error.response.status + ' )'
      )
    }

    /* if (error.response?.status === 409) {
      toast.loading('Processing...')
    } */

    console.error(error)

    return Promise.reject(error)
  }
)

export default axiosClient
